import * as React from 'react'

import { Alert, Box, Button } from '@factorialco/deprecated-design-system'
import { type SelectOption } from '@factorialco/deprecated-design-system'
import { publicSiteLocation } from 'config/Vars'
import copy from 'copy-to-clipboard'
import { Form } from 'factorial-form'
import param from 'jquery-param'
import pickBy from 'lodash/pickBy'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import Select from 'modules/core/components/Inputs/Select'
import Text from 'modules/core/components/Inputs/Text'
import Modal from 'modules/core/components/Modal'
import helpCenterUrl from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'
import app from 'modules/core/store/models/app'

import teams from 'modules/teams/store/collections/teams'

interface Props {
  onClose: () => void
}

export const ExportModal = observer(({ onClose }: Props) => {
  const form = React.useMemo(
    () =>
      new Form(
        {
          url: '',
          team_id: null,
          token: users.current.attributes.calendar_token,
        },
        {
          url: 'string',
          team_id: 'number',
          token: 'string',
        }
      ),
    []
  )
  React.useEffect(() => {
    const params = {
      team_id: form.get('team_id').value,
      token: form.get('token').value,
    }

    const url =
      form.get('team_id').value === 'own'
        ? `${publicSiteLocation}/icals?token=${params.token}&own=true`
        : `${publicSiteLocation}/icals?${param(pickBy(params))}`
    form.setValues({
      url,
    })
  }, [form.get('team_id').value]) // eslint-disable-line react-hooks/exhaustive-deps

  const teamOptions: SelectOption[] = teams.models.map((team) => ({
    label: i18n.t('calendar.export.calendar_team', {
      team: team.attributes.name,
    }),
    value: team.attributes.id,
  }))

  const options = [
    {
      label: i18n.t('calendar.export.calendar_with_all_teams'),
      value: null,
    },
    {
      label: i18n.t('calendar.export.own_calendar'),
      value: 'own',
    },
    ...teamOptions,
  ]

  const onCopy = () => {
    copy(form.get('url').value)
    app.setFlash({
      type: 'correct',
      message: i18n.t('calendar.export.copied_successfully'),
    })
  }

  return (
    <Modal
      illustration="user-calendar"
      title={i18n.t('calendar.export.title')}
      description={i18n.t('calendar.export.description')}
      onClose={onClose}
    >
      {options.length > 1 && (
        <FormRow>
          <Select
            label={i18n.t('calendar.export.calendar_team')}
            field={form.get('team_id')}
            options={options}
          />
        </FormRow>
      )}
      <FormRow>
        <Box flexDirection="column" flexGrow gap="s8">
          <Text readonly label={i18n.t('calendar.export.calendar_url')} field={form.get('url')} />
          <Button type="secondary" onClick={onCopy}>
            {i18n.t('calendar.export.copy')}
          </Button>
        </Box>
      </FormRow>
      <FormRow>
        <Alert color="warning">
          {i18n.tView('calendar.export.more_info_with_link', {
            link: (
              <a
                rel="nofollow noopener noreferrer"
                target="_blank"
                href={helpCenterUrl('export_calendar')}
              >
                {i18n.t('calendar.export.description_link')}
              </a>
            ),
          })}
        </Alert>
      </FormRow>
    </Modal>
  )
})
